import React, {useContext, useEffect, useState} from "react";
import {connect} from "react-redux";
import { Button, Divider, Grid, Header, Icon, Image, Label, Segment, SegmentGroup } from "semantic-ui-react";
import MomentCustomer from './../MomentCustomer/MomentCustomer';
import GlobalContext from "./../../contexts/GlobalContext";
import './BookingRoomingDetail.css';
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";
import useRouter from "../../hooks/useRouter";

const mapProps = (state) => ({
    bookingsCompletionRates: state.booking.bookingsCompletionRates
});
const mapDispatch = (dispatch) => ({
    handleSuccessSelfCheckinModal: dispatch.modal.handleModal
});

const BookingRoomingDetail = props => {
    const [isSuccessPreCheckin, setIsSuccessPreCheckin] = useState(false);
    const [globalContext] = useContext(GlobalContext);
    const router = useRouter();
    const fromSelfCheckin = useFromSelfCheckin(router.location);

    useEffect(() => {
        setIsSuccessPreCheckin(props?.bookingsCompletionRates[props?.booking?.id]?.rate === 100)
    }, [props.bookingsCompletionRates]);

    let urlImage = '';
    if(props.detailsRoom !== undefined && props.detailsRoom !== null) {
        if(props.detailsRoom.photos !== undefined && props.detailsRoom.photos !== null) {
            urlImage = props.detailsRoom.photos[0];
        }
    }
    return (
        <SegmentGroup key={props.booking.id} raised style={{ backgroundColor: "white" }}>
            <Grid style={{ height: "auto" }} verticalAlign="middle" columns={2}>
                <Grid.Row only="computer" style={{ height: "100%" }}>
                    <Grid.Column mobile={16} computer={8} id="alignSelfImage">
                        <Image label={<Label as="a" color="blue" style={{ marginLeft: "2rem", marginTop: "1rem" }} ribbon><Icon name="hotel" />{props.booking.roomType}</Label>} className="p-3" src={urlImage} ui={true} />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} verticalAlign="middle" className="pl-4 pr-5 pb-3 pt-3">
                        <Grid.Row only="computer">
                            <div>
                                <h3 className="title-mb" style={{ textAlign: "center" }}>
                                    <span className="mr-5 mbBlue"><Icon name="male" />{props.booking.paxTotal}</span>
                                    <Icon className="mr-0 mbBlue" name="calendar alternate" />
                                    <span className="ml-1 mr-1" ><MomentCustomer format="L">{props.booking.arrivalDate}</MomentCustomer></span>
                                    <Icon name="long arrow alternate right" style={{ margin: "0" }} />
                                    <span className="ml-1"><MomentCustomer format="L">{props.booking.departureDate}</MomentCustomer></span>
                                </h3>
                            </div>
                        </Grid.Row>
                        <Grid.Row verticalAlign="middle" only="computer">
                            <Grid.Column computer={16} verticalAlign="middle">
                                <Header className="mt-3" textAlign="center" as="h3"><p style={{ color: props.colorGlobalCompletionRate }}>{props.preCheckInMessage} {props.bookingCompletionRate} %</p> {props.preCheckInAddMessage}</Header>
                                
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={16} stretched verticalAlign="middle" className="pb-3">
                                <Grid.Row>
                                    {props.addButtons}
                                </Grid.Row>
                                {
                                    fromSelfCheckin.isFromSelfCheckin && isSuccessPreCheckin ?
                                        <Grid.Row>
                                            <Grid.Column computer={16} verticalAlign="middle">
                                                <Button
                                                    className="roomAccessAction"
                                                    content={globalContext.translations.getRoomAccessActionsLink}
                                                    color="blue"
                                                    fluid
                                                    onClick={() => props.handleSuccessSelfCheckinModal({successSelfCheckinModal: true})}
                                                />
                                            </Grid.Column>
                                        </Grid.Row>
                                    :
                                        null
                                }
                            </Grid.Column>
                        </Grid.Row>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row only="mobile tablet">
                    <Grid.Column mobile={16} computer={8}>
                        <Image label={<Label as="a" color="blue" style={{ marginLeft: "1rem", marginTop: "1rem" }} ribbon><Icon name="hotel" />{props.booking.roomType}</Label>} src={urlImage} ui={true} />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} verticalAlign="middle" /*className="pl-4 pr-4 pb-1"*/>
                        <Segment textAlign="center" className="bookingDetail">
                            <span className="mr-4"><Icon name="user" />{props.booking.paxTotal}</span>
                            <span className="ml-3 mr-1"><MomentCustomer format="L">{props.booking.arrivalDate}</MomentCustomer></span>
                            <Icon name="long arrow alternate right" />
                            <span className=""><MomentCustomer format="L">{props.booking.departureDate}</MomentCustomer></span>
                        </Segment>
                        <Header className="mt-3" textAlign="center" as="h3">{globalContext.translations.preCheckInAddMessage}</Header>
                        <Grid.Row>
                            {props.addButtons}
                        </Grid.Row>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </SegmentGroup>
    )
};

export default connect(mapProps, mapDispatch)(BookingRoomingDetail);